import type { IconSvgObject } from './types';

const AwsLambdaIcon: IconSvgObject = [
  ["path", { d: "M6 6V4C6 3.44772 6.44772 3 7 3H10.7639C11.5215 3 12.214 3.42801 12.5528 4.10557L19 17H20C20.5523 17 21 17.4477 21 18V20C21 20.5523 20.5523 21 20 21H17.2361C16.4785 21 15.786 20.572 15.4472 19.8944L9 7H7C6.44772 7 6 6.55228 6 6Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.38197 21H3.7942C3.35558 21 3 20.6444 3 20.2058C3 20.0708 3.0344 19.9381 3.09994 19.8201L8 11L10.5 16L8.27639 20.4472C8.107 20.786 7.76074 21 7.38197 21Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default AwsLambdaIcon;
